import qs from "query-string";
import { useRouter } from "./useRouter";

export const useSearchParams = () => {
  const router = useRouter();
  return qs.parse(router.location.search);
};
